export default __webpack_public_path__ + "static/media/logo_v1.fdff99a7.png";